import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { GradientButton } from '../gradients/GradientButton';
import { GradientIcon } from '../gradients/GradientIcon';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { SignInMenu } from './SignInMenu';

import { useRef, useState } from 'react';
import { AvatarNext } from '../AvatarNext';
import { useAuth } from 'src/contexts/AuthContext';
import { useAuthModal } from 'src/hooks/useAuthModal';

export function UserButton() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const { user, userData, handleSignOut } = useAuth();
  const { openAuthModal } = useAuthModal();
  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const handleMenuToggle = () => {
    setMenuOpen((prev) => {
      return !prev;
    });
  };
  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const handleMenuClose = () => {
    setMenuOpen(false);
  };
  return (
    <Box>
      {!user?.uid ? (
        <GradientButton
          size="large"
          variant="outlined"
          onClick={() => {
            return openAuthModal();
          }}
          startIcon={AccountBalanceWalletOutlinedIcon}
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          {/* <Typography variant="buttonLarge">Sign In</Typography> */}
          Sign In
        </GradientButton>
      ) : (
        <ButtonBase
          ref={menuRef}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '25px',
          }}
          onClick={handleMenuToggle}
        >
          <AvatarNext
            variant="gradientOutlined"
            src={userData?.imgUrl}
            sx={{ '&:hover': { cursor: 'pointer' } }}
          />
          <GradientIcon IconComponent={ArrowDropDownIcon} />
        </ButtonBase>
      )}
      {menuOpen && menuRef?.current && (
        <SignInMenu
          logout={handleSignOut}
          open={menuOpen}
          anchorEl={menuRef.current}
          handleMenuClose={handleMenuClose}
        />
      )}
    </Box>
  );
}

// { {!isAuthenticated ? (
//   <GradientButton
//     size="large"
//     variant="outlined"
//     onClick={login}
//     startIcon={AccountBalanceWalletOutlinedIcon}
//     sx={{
//       whiteSpace: 'nowrap',
//     }}
//   >
//     {/* <Typography variant="buttonLarge">Sign In</Typography> */}
//     Sign In
//   </GradientButton>
// ) : walletConnected && (username || addresses) ? (
//   <GradientButton
//     size="large"
//     ref={menuRef}
//     variant="outlined"
//     onClick={handleMenuToggle}
//     sx={{ mr: 1, whiteSpace: 'nowrap' }}
//     endIcon={ArrowDropDownIcon}
//   >
//     {username
//       ? `${username?.length > 12 ? truncate(username) : username}${
//           addresses ? ` | ${truncate(addresses[0])}` : ''
//         }`
//       : ''}
//   </GradientButton>
// ) : (
//   <ButtonGroup sx={{ mr: 1 }} ref={menuRef}>
//     <GradientButton
//       size="large"
//       onClick={handleMenuToggle}
//       endIcon={ArrowDropDownIcon}
//       variant="outlined"
//       sx={{
//         whiteSpace: 'nowrap',
//       }}
//     >
//       {username?.length > 10 ? truncate(username) : username}
//     </GradientButton>
//     {/* TODO: Add linking wallet <GradientButton
//       size="large"
//       variant="outlined"
//       startIcon={AddIcon}
//       sx={{
//         whiteSpace: 'nowrap',
//       }}
//     >
//       Wallet
//     </GradientButton> */}
//   </ButtonGroup>
// )}
